import { iconUrl } from '#/utils/assetUrl';

export default function HeroOrbital() {
  return (
    <div className="hero-orbital">
      <img
        src={iconUrl('hero-orbital-visual-bg.png')}
        alt=""
        className="hero-orbital-layer hero-orbital-bg"
      />
      <div className="hero-orbital-cards-track hero-orbital-cards-track--row1">
        <img
          src={iconUrl('hero-orbital-visual-first-line.png')}
          alt=""
          className="hero-orbital-cards-img"
        />
        <img
          src={iconUrl('hero-orbital-visual-first-line.png')}
          alt=""
          className="hero-orbital-cards-img"
          aria-hidden="true"
        />
      </div>
      <div className="hero-orbital-cards-track hero-orbital-cards-track--row2">
        <img
          src={iconUrl('hero-orbital-visual-second-line.png')}
          alt=""
          className="hero-orbital-cards-img"
        />
        <img
          src={iconUrl('hero-orbital-visual-second-line.png')}
          alt=""
          className="hero-orbital-cards-img"
          aria-hidden="true"
        />
      </div>
      <img
        src={iconUrl('hero-orbital-visual-phone.png')}
        alt="정부 혜택앱 화면"
        className="hero-orbital-layer hero-orbital-phone"
      />
    </div>
  );
}
